export default "__VITE_ASSET__75bS2hUL__"